import React, { useCallback, useEffect, useRef } from "react";
import { useState, useContext } from "react";
import { API_KEY, baseUrl, imageUrl2 } from "../Constants/Constance";
import { PopUpContext } from "../Context/moviePopUpContext";
// import useUpdateMylist from "../CustomHooks/useUpdateMylist";
import axios from "../axios";
// import MoviePopUp from "../components/PopUp/MoviePopUp";
// import usePlayMovie from "../CustomHooks/usePlayMovie";
// import useUpdateLikedMovies from "../CustomHooks/useUpdateLikedMovies";
// import useGenereConverter from "../CustomHooks/useGenereConverter";
import StarRatings from "react-star-ratings";
import Navbar from "../components/Header/Navbar";
import axiosClient from "../axios-client";
import { useLocation } from "react-router-dom";
import usePlayMovie from "../CustomHooks/usePlayMovie";
import usePlaySerie from "../CustomHooks/usePlaySerie";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { AuthContext } from "../Context/UserContext";
import usePlayVideo from "../CustomHooks/usePlayVideo";
import ContentPopup from "../components/Popup/ContentPopup";
import { motion, AnimatePresence } from "framer-motion";
import SeriePopup from "../components/Popup/SeriePopup";

function Search() {
  const [showModal, setShowModal] = useState(false);
  const { user, profileId, userCountryCode } = useContext(AuthContext);
  const [dataFavorites, setDataFavorites] = useState([])
  const [searchTerm, setSearchTerm] = useState('');
  // const { addToMyList, PopupMessage } = useUpdateMylist();
  // const { playMovie } = usePlayMovie();
  // const { addToLikedMovies } = useUpdateLikedMovies();
  // const { convertGenere } = useGenereConverter();
  const location = useLocation()
  const [searchQuery, setSearchQuery] = useState("");
  const [contents, setContents] = useState([]);
  const [moviePopupInfo, setMoviePopupInfo] = useState({});
  const { playMovie } = usePlayMovie();
  const { playSerie } = usePlaySerie();
  const [hasMore, setHasMore] = useState(true);
  const [page, setPage] = useState(1); // Start from page 1
  const [isLoading, setIsLoading] = useState(false);
  const [shouldPop, setshouldPop] = useState(true);
  const [isHovered, setIsHovered] = useState(false);
  const { playVideo } = usePlayVideo();

  const [isHoveredCard, setIsHoveredCard] = useState(false);
  const [hoveredCardIndex, setHoveredCardIndex] = useState(null);

  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  useEffect(() => {
    const handleResize = () => {
      setScreenWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fetchData = async (newPage) => {
    setIsLoading(true);
    try {
      const response = await axiosClient.get(
        `content/?page_size=24&page=${newPage}&search_term=${searchTerm}&profile_id=${profileId}`
      );
      if (response.data.results.length > 0) {
        setContents((prevContent) => {
          const newContent = response.data.results.filter(
            (item) => !prevContent.some((prevItem) => prevItem.id === item.id)
          );
          return [...prevContent, ...newContent];
        });
        setHasMore(!!response.data.next); // Stop fetching if there's no next page
      }

    } catch (error) {
      // console.error("Error fetching data: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const observer = useRef();
  const lastContentRef = useCallback(
    (node) => {
      if (isLoading) return;
      if (observer.current) observer.current.disconnect();
      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMore) {
          setPage((prevPage) => prevPage + 1);
        }
      }, {
        rootMargin: '100px', // Adjust as needed
      });
      if (node) observer.current.observe(node);
    },
    [isLoading, hasMore]
  );

  useEffect(() => {
    if (userCountryCode && profileId) {
      fetchData(page);
    }
  }, [page, userCountryCode, profileId]);

  //   const Search = (searchTerm) => {
  //   setSearchTerm(searchTerm); // Update the searchTerm with the passed value
  // };
  const Search = async (searchTerm) => {
    setPage(1); // Reset to the first page when a new search is performed
    try {
      const response = await axiosClient.get(
        `content/?page_size=24&page=${1}&search_term=${searchTerm}&profile_id=${profileId}`
      );

      setContents(response.data.results || []);
      setHasMore(!!response.data.next); // Set the state to indicate if there's more data
    } catch (error) {
      // console.error("Error fetching data: ", error);
    }
  };
  const handleMoviePopup = (movieInfo) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (movieInfo?.pays_codes?.length > 0 && !movieInfo?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    if (shouldPop) {

      setMoviePopupInfo(movieInfo);
      setShowModal(true);
    }
  };

  const handlePlayClick = async (content, type) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;

    }
    if (content?.pays_codes?.length > 0 && !content?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    playVideo(content?.id, type === "movie" ? "movie" : "episode")

  }
  const handleFavoriteClick = async (content, title) => {
    if (!userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (content?.pays_codes?.length > 0 && !content?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce film n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      // alert("Désolé, ce film n'est pas disponible dans votre pays.");
      return;
    }
    if (content.isLiked) {
      // If already favorited, remove it
      try {
        const response = await axiosClient.delete(`favorites/delete/${profileId}/${content.id}/`);
        if (response.status === 204) {
          setContents(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: false
                };
              }
              return val;
            });
          });
          // setDataFavorites(dataFavorites.filter(e => !(e.profile === parseInt(profileId) && e.content === parseInt(content.id))))

          setMoviePopupInfo({ ...moviePopupInfo, isLiked: false });
        }
        toast.error(`${title} a été retiré de vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error removing from favorites', error);
      }
    } else {
      // If not favorited, add it
      try {
        const response = await axiosClient.post('favorites/create/', {
          profile: profileId,
          content: content.id,
        });
        if (response.status === 201) {
          setContents(prevData => {
            return prevData.map(val => {
              if (val.id === content?.id) {
                return {
                  ...val,
                  isLiked: true
                };
              }
              return val;
            });
          });
          // setDataFavorites([...dataFavorites, {
          //   profile: parseInt(profileId),
          //   content: parseInt(content.id)
          // }])
          setMoviePopupInfo({ ...moviePopupInfo, isLiked: true });
        }
        toast.success(`${title} a été ajouté à vos favoris.`, {
          position: "top-right",
          autoClose: 3000,

        });
      } catch (error) {
        // console.error('Error adding to favorites', error);
      }
    }
  };

  const modalRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (modalRef.current && !modalRef.current.contains(event.target)) {
        setShowModal(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [setShowModal]);

  const handleCardClick = (obj) => {
    if (!isLoading && !userCountryCode) {
      // alert("Error: Impossible de déterminer votre emplacement.");
      toast.error(`Impossible de déterminer votre emplacement.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }
    if (obj?.pays_codes?.length > 0 && !obj?.pays_codes?.includes(userCountryCode)) {
      toast.error(`Désolé, ce contenu n'est pas disponible dans votre pays.`, {
        position: "top-right",
        autoClose: 3000,

      });
      return;
    }

    obj.type === "series" ? playSerie(obj) : playMovie(obj)
  };
  return (
    <div className="min-h-screen">
      <ToastContainer />

      {/* {PopupMessage} */}
      <Navbar></Navbar>
      <div className="  flex px-5 justify-center mt-28 mb-8">

        <input
          onChange={(e) =>
            setSearchTerm(e.target.value)

          }
          value={searchTerm}
          type="text"
          className="w-[60%] xl:w-1/3 bg-white/20 text-white outline-none sm:text-sm rounded focus:ring-primary-600 focus:border-primary-600 block p-2.5 placeholder:text-white"
          placeholder="Chercher par titre, par acteur..."
          required=""
        ></input>
        <button
          style={{
            background: "linear-gradient(to right, #eb6820, #fd9358)",
          }}
          onClick={() => Search(searchTerm)}
          className="flex items-center px-8 text-white -ml-2 focus:outline-none focus:ring-primary-300 transition ease-in-out font-medium rounded text-sm py-1 text-center dark:bg-primary-600 dark:hover:bg-primary-700 dark:focus:ring-primary-800"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 items-center text-white mt-auto mb-auto pr-4 cursor-pointer"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            strokeWidth={2}
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
            />
          </svg>{" "}
          Chercher
        </button>
      </div>

      {/* Search results */}
      <div className="grid-cols-3 space-x-2 sm:grid-cols-4 grid p-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 3xl:grid-cols-6 md:p-5 space-y-1 lg:space-y-0 lg:grid lg:gap-3 lg:grid-rows-3">

        {contents.map((content, index) => {
          // const converted = convertGenere(movie.genre_ids);
          const isLastItem = contents.length - 1 === index;
          return (
            <div onClick={() => handleCardClick(content)} className="cursor-pointer p-1  mb-5"
              key={content.id}
              ref={isLastItem ? lastContentRef : null}
            >
              <div onMouseEnter={() => setHoveredCardIndex(index)}
                onMouseLeave={() => setHoveredCardIndex(null)}
                className=" hover:scale-105 hover:border-2 group relative block overflow-hidden rounded-xl transition-all duration-500">
                {hoveredCardIndex === index ? (
                  <video
                  className={`${screenWidth < 700 ? "w-full h-[190px] sm:h-[200px] object-fill" : "min-h-[150px] max-h-[150px] w-[100%] object-cover"} `}

                    src={content.trailerUrl}
                    poster={screenWidth < 700 ? content.poster : content.image}
                    onPause={() => setIsHoveredCard(false)}
                    autoPlay
                    muted
                    loop
                  />
                ) : (
                  <a
                    className="lightbox transition-all duration-500 group-hover:scale-105 tobii-zoom"
                    title=""
                  >
                    <img

                      className={`${screenWidth < 700 ? "w-full h-[190px] sm:h-[200px] object-fill" : "min-h-[150px] max-h-[150px] w-[100%] object-cover"} `}
                      src={
                        content.image
                          ? screenWidth < 700 ? content.poster : content.image
                          : "https://play-lh.googleusercontent.com/Oyl8qNPlgau19prJodKkddTMAJvS3PiDskUtSUTkefp6KyiwSa7K7BTZU1GiyNOeUPKC=w240-h480-rw"
                      }
                    />
                  </a>)}
                <div

                  style={{
                    background:
                      "linear-gradient(0deg, hsl(0deg 0% 4% / 92%) 0%, hsl(0deg 0% 0% / 50%) 35%, hsl(220deg 26% 44% / 0%) 100%)",
                  }}
                  className=" hidden md:block absolute -bottom-42 group-hover:bottom-0 w-full transition-all duration-500 p-4 rounded"
                >
                  {content.logo &&
                    <div className="mb-2 text-white mt-2 ml-4 font-medium h-[50px] w-[100px] flex  ">
                      <img className="object-fit" src={content.logo} />
                    </div>}
                  <div className="flex mb-1 transition ease-in-out delay-150">
                    <div
                      onClick={(e) =>
                      (
                        e.stopPropagation(),
                        // content.type === "series" ? playSerie(content) : playMovie(content)
                        handlePlayClick(content, content.type)


                      )

                      }
                      // onMouseEnter={() => setshouldPop(false)}
                      // onMouseLeave={() => setshouldPop(true)}
                      className="cursor-pointer text-white w-9 h-9 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[2px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M5.25 5.653c0-.856.917-1.398 1.667-.986l11.54 6.348a1.125 1.125 0 010 1.971l-11.54 6.347a1.125 1.125 0 01-1.667-.985V5.653z"
                        />
                      </svg>
                    </div>

                    <div
                      onClick={(e) => (
                        e.stopPropagation(),
                        handleFavoriteClick(content, content.title))}
                      // onMouseEnter={() => setshouldPop(false)}
                      // onMouseLeave={() => setshouldPop(true)}
                      className="cursor-pointer text-white w-9 h-9 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                    >
                      {content.isLiked ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="white"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                          />
                        </svg>
                      )}
                    </div>

                    <div
                      onClick={(e) => (
                        e.stopPropagation(),
                        handleMoviePopup(content))}
                      className=" cursor-pointer text-white w-9 h-9 border-[2px] rounded-full p-2 mr-1 backdrop-blur-[1px] shadow-md ease-linear transition-all duration-150 hover:text-black hover:bg-white"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="text-shadow-xl"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M19.5 8.25l-7.5 7.5-7.5-7.5"
                        />
                      </svg>
                    </div>
                  </div>

                  {/* <a
                    className="hover:text-primary-600 text-shadow-xl shadow-orange-700 text-white text-base 2xl:text-lg transition duration-500 font-medium"
                  >
                    {(content.title?.length > 20)
                      ? `${content.title.slice(0, 20)}...`
                      : content.title}
                  </a> */}


                  {/* <br></br> */}
                  {/* <StarRatings
                      rating={movie.vote_average / 2}
                      starRatedColor="red"
                      numberOfStars={5}
                      name="rating"
                      starDimension="1.2rem"
                    /> */}
                  {/* <br></br> */}
                  {/* <div className="mt-1">
                      {converted &&
                        converted.map((genre) => {
                          return (
                            <span className="text-white mr-4 text-xs  2xl:text-sm font-thin">
                              {genre}
                            </span>
                          );
                        })}
                    </div> */}
                </div>
              </div>
            </div>
          );
        })}
        {isLoading && <div className="flex items-center justify-center" role="status">
          <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin dark:text-gray-600 fill-orange-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
          </svg>
          <span className="sr-only">Loading...</span>
        </div>}



      </div>
      {(!isLoading && contents?.length === 0) &&
        <div className="w-full flex items-center justify-center" role="status">
          <span className="text-white text-center">Aucun contenu trouvé</span>
        </div>}
      <>
        {/* Movie Pop Up section */}
        <AnimatePresence>

          {showModal && (
            moviePopupInfo.type === "series" ? <>
              <SeriePopup
                modalRef={modalRef}
                popupInfo={moviePopupInfo}
                playSerie={playSerie}
                playMovie={playMovie}
                handleFavoriteClick={handleFavoriteClick}
                setShowModal={setShowModal}
              />
              <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
            </> :
              <>
                <ContentPopup
                  modalRef={modalRef}
                  popupInfo={moviePopupInfo}
                  playSerie={playSerie}
                  playMovie={playMovie}
                  handleFavoriteClick={handleFavoriteClick}
                  setShowModal={setShowModal}
                />
                <div className="opacity-50 fixed inset-0 z-40 bg-gray-800"></div>
              </>
          )}
        </AnimatePresence>
      </>
      {/* {showModal ? <MoviePopUp data1={moviePopupInfo} /> : null} */}
    </div>
  );
}

export default Search;
